/** Client View layout on tablets and phones, the same rules as the Sales View (salesViewLayout). */
export { initialShowMap } from '../sales-view/salesViewLayout';

export const LS_CV_SHOW_MAP = 'sift:client-view:showMap';

export interface ClientSheetSelections {
  managers: string[];
  marketCenters: string[];
  rdsTerritories: string[];
  cseReps: string[];
  tiers: string[];
  priorities: string[];
  inspectorActive: boolean;
}

/** Selections hidden behind the phone's Filters button, so its badge says how many are on. */
export function countClientSheetFilters(s: ClientSheetSelections): number {
  return (
    s.managers.length +
    s.marketCenters.length +
    s.rdsTerritories.length +
    s.cseReps.length +
    s.tiers.length +
    s.priorities.length +
    (s.inspectorActive ? 1 : 0)
  );
}
